module.exports = __webpack_public_path__ + "473e07672cc2f0b485a443ba528daa9e.png";